var _defs, _g, _path, _path2, _g2, _line, _line2, _path3, _path4, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectPillar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-7084d607-cdc3-4316-9a71-f2df1be89062",
    "data-name": "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1680.05 279.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-eb89ac0e-a92b-4fa7-be15-885f73467d1e",
    "data-name": "projectPillar"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    points: "24.65 237.87 27 267.26 1659.95 270.53 1661.83 240.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M26.47,228.51s1380.54,3.02,1632.95,3.27c10.15-.06,9.95,9.56,0,9.41-380.28-.97-1307.93-2.8-1632.95-3.27-6.9.24-7.57-9.11,0-9.41Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 1659.42,
    y1: 231.78,
    x2: 29.07,
    y2: 228.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 29.07,
    y1: 74.92,
    x2: 1660.11,
    y2: 78.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M27.16,65.48s1380.54,3.02,1632.95,3.27c10.15-.06,9.95,9.56,0,9.41-380.28-.97-1307.93-2.8-1632.95-3.27-6.9.24-7.57-9.11,0-9.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-0677bc82-8127-4b7b-bf81-d50705ec3b28",
    "data-name": "swirls"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-610442bd-bf49-4ddf-bd03-99ae10fba5bb",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M276.13,50.57c2.68,2.1,7.06.94,8.82-1.98s1.05-6.91-1.17-9.49c-1.38-1.6-3.28-2.74-5.34-3.2-3.78-.85-7.76.6-10.93,2.83-3.17,2.22-5.74,5.18-8.56,7.85-15.9,15.08-35.77,18.75-58.07,18.97-7.32-.23-27.82,1.8-33.17-11.4-1-2.46-1.37-5.12-1.63-7.76-.51-5.22-.52-10.86,2.37-15.24,2.45-3.72,6.71-5.97,11.07-6.88,4.36-.91,8.88-.64,13.32-.25,6.22,1.01,8.42,7.07,8.5,9.32.21,5.99-.09,12.8-5.36,15.66-2.1,1.14-4.54,1.46-6.92,1.54-3.24.11-6.65-.25-9.34-2.07s-4.38-5.42-3.14-8.42c1.33-3.22,5.98-6.98,14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M271.19,23.3c2.26-.43,4.56-.71,6.86-.53,5.72.45,13.99,3.52,17.34,8.18,3.35,4.67,8.49,18.7-1.42,29.31-4.55,4.65-13.9,5.48-16.27,5.46-5.38-.04-10.13-1.84-13.04-6.37-1.82-2.82-3.16-7.99-2.33-11.25.82-3.26,2.31-6.35,5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M196.57,65.69c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.22-33.19,45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M187.99,65.4c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.44-33.36,45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M186.99,65.23c7.62.11,20.28-5.93,21.77-6.78,22.94-13.12,26.53-33.95,43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M195.99,49c31.09-11.09,27-24.63,43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-05adf9f0-cc87-4e28-a175-0bceaa02fb2c",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M53.32,49.86c-2.68,2.1-7.06.94-8.82-1.98s-1.05-6.91,1.17-9.49c1.38-1.6,3.28-2.74,5.34-3.2,3.78-.85,7.76.6,10.93,2.83s5.74,5.18,8.56,7.85c15.9,15.08,35.77,18.75,58.07,18.97,7.32-.23,27.82,1.8,33.17-11.4,1-2.46,1.37-5.12,1.63-7.76.51-5.22.52-10.86-2.37-15.24-2.45-3.72-6.71-5.97-11.07-6.88-4.36-.91-8.88-.64-13.32-.25-6.22,1.01-8.42,7.07-8.5,9.32-.21,5.99.09,12.8,5.36,15.66,2.1,1.14,4.54,1.46,6.92,1.54,3.24.11,6.65-.25,9.34-2.07s4.38-5.42,3.14-8.42c-1.33-3.22-5.98-6.98-14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M58.26,22.59c-2.26-.43-4.56-.71-6.86-.53-5.72.45-13.99,3.52-17.34,8.18-3.35,4.67-8.49,18.7,1.42,29.31,4.55,4.65,13.9,5.48,16.27,5.46,5.38-.04,10.13-1.84,13.04-6.37,1.82-2.82,3.16-7.99,2.33-11.25s-2.31-6.35-5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M132.88,64.98c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.22-33.19-45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M141.46,64.7c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.44-33.36-45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M142.47,64.52c-7.62.11-20.28-5.93-21.77-6.78-22.94-13.12-26.53-33.95-43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M133.46,48.29c-31.09-11.09-27-24.63-43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-312ef1e9-0e5f-409e-b431-d46e8b7684b2",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M820.81,52.22c2.68,2.1,7.06.94,8.82-1.98s1.05-6.91-1.17-9.49c-1.38-1.6-3.28-2.74-5.34-3.2-3.78-.85-7.76.6-10.93,2.83-3.17,2.22-5.74,5.18-8.56,7.85-15.9,15.08-35.77,18.75-58.07,18.97-7.32-.23-27.82,1.8-33.17-11.4-1-2.46-1.37-5.12-1.63-7.76-.51-5.22-.52-10.86,2.37-15.24,2.45-3.72,6.71-5.97,11.07-6.88,4.36-.91,8.88-.64,13.32-.25,6.22,1.01,8.42,7.07,8.5,9.32.21,5.99-.09,12.8-5.36,15.66-2.1,1.14-4.54,1.46-6.92,1.54-3.24.11-6.65-.25-9.34-2.07s-4.38-5.42-3.14-8.42c1.33-3.22,5.98-6.98,14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M815.87,24.95c2.26-.43,4.56-.71,6.86-.53,5.72.45,13.99,3.52,17.34,8.18,3.35,4.67,8.49,18.7-1.42,29.31-4.55,4.65-13.9,5.48-16.27,5.46-5.38-.04-10.13-1.84-13.04-6.37-1.82-2.82-3.16-7.99-2.33-11.25.82-3.26,2.31-6.35,5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M741.25,67.33c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.22-33.19,45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M732.67,67.05c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.44-33.36,45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M731.67,66.87c7.62.11,20.28-5.93,21.77-6.78,22.94-13.12,26.53-33.95,43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M740.67,50.64c31.09-11.09,27-24.63,43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-5dd90458-719c-4ffb-b8ed-bf53b905bcbd",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M598,51.51c-2.68,2.1-7.06.94-8.82-1.98s-1.05-6.91,1.17-9.49c1.38-1.6,3.28-2.74,5.34-3.2,3.78-.85,7.76.6,10.93,2.83s5.74,5.18,8.56,7.85c15.9,15.08,35.77,18.75,58.07,18.97,7.32-.23,27.82,1.8,33.17-11.4,1-2.46,1.37-5.12,1.63-7.76.51-5.22.52-10.86-2.37-15.24-2.45-3.72-6.71-5.97-11.07-6.88-4.36-.91-8.88-.64-13.32-.25-6.22,1.01-8.42,7.07-8.5,9.32-.21,5.99.09,12.8,5.36,15.66,2.1,1.14,4.54,1.46,6.92,1.54,3.24.11,6.65-.25,9.34-2.07s4.38-5.42,3.14-8.42c-1.33-3.22-5.98-6.98-14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M602.94,24.24c-2.26-.43-4.56-.71-6.86-.53-5.72.45-13.99,3.52-17.34,8.18-3.35,4.67-8.49,18.7,1.42,29.31,4.55,4.65,13.9,5.48,16.27,5.46,5.38-.04,10.13-1.84,13.04-6.37,1.82-2.82,3.16-7.99,2.33-11.25s-2.31-6.35-5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M677.56,66.63c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.22-33.19-45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M686.14,66.34c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.44-33.36-45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M687.14,66.17c-7.62.11-20.28-5.93-21.77-6.78-22.94-13.12-26.53-33.95-43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M678.14,49.94c-31.09-11.09-27-24.63-43.9-26.25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-20254e6b-cf16-47cf-a223-412e1c5918e3",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M546.13,51.11c2.68,2.1,7.06.94,8.82-1.98s1.05-6.91-1.17-9.49c-1.38-1.6-3.28-2.74-5.34-3.2-3.78-.85-7.76.6-10.93,2.83-3.17,2.22-5.74,5.18-8.56,7.85-15.9,15.08-35.77,18.75-58.07,18.97-7.32-.23-27.82,1.8-33.17-11.4-1-2.46-1.37-5.12-1.63-7.76-.51-5.22-.52-10.86,2.37-15.24,2.45-3.72,6.71-5.97,11.07-6.88,4.36-.91,8.88-.64,13.32-.25,6.22,1.01,8.42,7.07,8.5,9.32.21,5.99-.09,12.8-5.36,15.66-2.1,1.14-4.54,1.46-6.92,1.54-3.24.11-6.65-.25-9.34-2.07s-4.38-5.42-3.14-8.42c1.33-3.22,5.98-6.98,14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M541.19,23.83c2.26-.43,4.56-.71,6.86-.53,5.72.45,13.99,3.52,17.34,8.18,3.35,4.67,8.49,18.7-1.42,29.31-4.55,4.65-13.9,5.48-16.27,5.46-5.38-.04-10.13-1.84-13.04-6.37-1.82-2.82-3.16-7.99-2.33-11.25.82-3.26,2.31-6.35,5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M466.57,66.22c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.22-33.19,45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M457.99,65.94c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.44-33.36,45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M456.98,65.76c7.62.11,20.28-5.93,21.77-6.78,22.94-13.12,26.53-33.95,43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M465.98,49.53c31.09-11.09,27-24.63,43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-0607a538-4496-4e92-8265-ae61eb6dd693",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M323.31,50.4c-2.68,2.1-7.06.94-8.82-1.98s-1.05-6.91,1.17-9.49c1.38-1.6,3.28-2.74,5.34-3.2,3.78-.85,7.76.6,10.93,2.83s5.74,5.18,8.56,7.85c15.9,15.08,35.77,18.75,58.07,18.97,7.32-.23,27.82,1.8,33.17-11.4,1-2.46,1.37-5.12,1.63-7.76.51-5.22.52-10.86-2.37-15.24-2.45-3.72-6.71-5.97-11.07-6.88-4.36-.91-8.88-.64-13.32-.25-6.22,1.01-8.42,7.07-8.5,9.32-.21,5.99.09,12.8,5.36,15.66,2.1,1.14,4.54,1.46,6.92,1.54,3.24.11,6.65-.25,9.34-2.07s4.38-5.42,3.14-8.42c-1.33-3.22-5.98-6.98-14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M328.26,23.13c-2.26-.43-4.56-.71-6.86-.53-5.72.45-13.99,3.52-17.34,8.18-3.35,4.67-8.49,18.7,1.42,29.31,4.55,4.65,13.9,5.48,16.27,5.46,5.38-.04,10.13-1.84,13.04-6.37,1.82-2.82,3.16-7.99,2.33-11.25s-2.31-6.35-5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M402.87,65.51c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.22-33.19-45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M411.45,65.23c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.44-33.36-45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M412.46,65.05c-7.62.11-20.28-5.93-21.77-6.78-22.94-13.12-26.53-33.95-43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M403.46,48.82c-31.09-11.09-27-24.63-43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-8b5f9e32-3cf1-4d0c-a581-3d8756d19b78",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1090.81,52.75c2.68,2.1,7.06.94,8.82-1.98s1.05-6.91-1.17-9.49c-1.38-1.6-3.28-2.74-5.34-3.2-3.78-.85-7.76.6-10.93,2.83-3.17,2.22-5.74,5.18-8.56,7.85-15.9,15.08-35.77,18.75-58.07,18.97-7.32-.23-27.82,1.8-33.17-11.4-1-2.46-1.37-5.12-1.63-7.76-.51-5.22-.52-10.86,2.37-15.24,2.45-3.72,6.71-5.97,11.07-6.88,4.36-.91,8.88-.64,13.32-.25,6.22,1.01,8.42,7.07,8.5,9.32.21,5.99-.09,12.8-5.36,15.66-2.1,1.14-4.54,1.46-6.92,1.54-3.24.11-6.65-.25-9.34-2.07s-4.38-5.42-3.14-8.42c1.33-3.22,5.98-6.98,14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1085.87,25.48c2.26-.43,4.56-.71,6.86-.53,5.72.45,13.99,3.52,17.34,8.18,3.35,4.67,8.49,18.7-1.42,29.31-4.55,4.65-13.9,5.48-16.27,5.46-5.38-.04-10.13-1.84-13.04-6.37-1.82-2.82-3.16-7.99-2.33-11.25.82-3.26,2.31-6.35,5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1011.25,67.87c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.22-33.19,45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1002.67,67.59c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.44-33.36,45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1001.66,67.41c7.62.11,20.28-5.93,21.77-6.78,22.94-13.12,26.53-33.95,43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1010.66,51.18c31.09-11.09,27-24.63,43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-038ad6b1-ff4e-4613-97c8-b84a770ba798",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M867.99,52.05c-2.68,2.1-7.06.94-8.82-1.98s-1.05-6.91,1.17-9.49c1.38-1.6,3.28-2.74,5.34-3.2,3.78-.85,7.76.6,10.93,2.83s5.74,5.18,8.56,7.85c15.9,15.08,35.77,18.75,58.07,18.97,7.32-.23,27.82,1.8,33.17-11.4,1-2.46,1.37-5.12,1.63-7.76.51-5.22.52-10.86-2.37-15.24-2.45-3.72-6.71-5.97-11.07-6.88-4.36-.91-8.88-.64-13.32-.25-6.22,1.01-8.42,7.07-8.5,9.32-.21,5.99.09,12.8,5.36,15.66,2.1,1.14,4.54,1.46,6.92,1.54,3.24.11,6.65-.25,9.34-2.07s4.38-5.42,3.14-8.42c-1.33-3.22-5.98-6.98-14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M872.94,24.77c-2.26-.43-4.56-.71-6.86-.53-5.72.45-13.99,3.52-17.34,8.18-3.35,4.67-8.49,18.7,1.42,29.31,4.55,4.65,13.9,5.48,16.27,5.46,5.38-.04,10.13-1.84,13.04-6.37,1.82-2.82,3.16-7.99,2.33-11.25s-2.31-6.35-5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M947.55,67.16c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.22-33.19-45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M956.13,66.88c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.44-33.36-45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M957.14,66.7c-7.62.11-20.28-5.93-21.77-6.78-22.94-13.12-26.53-33.95-43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M948.14,50.47c-31.09-11.09-27-24.63-43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-ab704264-4781-4b43-bfad-d6d27af51bab",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1362.35,52.99c2.68,2.1,7.06.94,8.82-1.98s1.05-6.91-1.17-9.49c-1.38-1.6-3.28-2.74-5.34-3.2-3.78-.85-7.76.6-10.93,2.83-3.17,2.22-5.74,5.18-8.56,7.85-15.9,15.08-35.77,18.75-58.07,18.97-7.32-.23-27.82,1.8-33.17-11.4-1-2.46-1.37-5.12-1.63-7.76-.51-5.22-.52-10.86,2.37-15.24,2.45-3.72,6.71-5.97,11.07-6.88,4.36-.91,8.88-.64,13.32-.25,6.22,1.01,8.42,7.07,8.5,9.32.21,5.99-.09,12.8-5.36,15.66-2.1,1.14-4.54,1.46-6.92,1.54-3.24.11-6.65-.25-9.34-2.07s-4.38-5.42-3.14-8.42c1.33-3.22,5.98-6.98,14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1357.4,25.72c2.26-.43,4.56-.71,6.86-.53,5.72.45,13.99,3.52,17.34,8.18,3.35,4.67,8.49,18.7-1.42,29.31-4.55,4.65-13.9,5.48-16.27,5.46-5.38-.04-10.13-1.84-13.04-6.37-1.82-2.82-3.16-7.99-2.33-11.25.82-3.26,2.31-6.35,5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1282.79,68.11c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.22-33.19,45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1274.21,67.82c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.44-33.36,45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1273.2,67.65c7.62.11,20.28-5.93,21.77-6.78,22.94-13.12,26.53-33.95,43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1282.2,51.42c31.09-11.09,27-24.63,43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-d4f826f0-79c4-4999-bd23-be62c7b27baa",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1139.53,52.28c-2.68,2.1-7.06.94-8.82-1.98s-1.05-6.91,1.17-9.49c1.38-1.6,3.28-2.74,5.34-3.2,3.78-.85,7.76.6,10.93,2.83s5.74,5.18,8.56,7.85c15.9,15.08,35.77,18.75,58.07,18.97,7.32-.23,27.82,1.8,33.17-11.4,1-2.46,1.37-5.12,1.63-7.76.51-5.22.52-10.86-2.37-15.24-2.45-3.72-6.71-5.97-11.07-6.88-4.36-.91-8.88-.64-13.32-.25-6.22,1.01-8.42,7.07-8.5,9.32-.21,5.99.09,12.8,5.36,15.66,2.1,1.14,4.54,1.46,6.92,1.54,3.24.11,6.65-.25,9.34-2.07s4.38-5.42,3.14-8.42c-1.33-3.22-5.98-6.98-14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1144.47,25.01c-2.26-.43-4.56-.71-6.86-.53-5.72.45-13.99,3.52-17.34,8.18-3.35,4.67-8.49,18.7,1.42,29.31,4.55,4.65,13.9,5.48,16.27,5.46,5.38-.04,10.13-1.84,13.04-6.37,1.82-2.82,3.16-7.99,2.33-11.25s-2.31-6.35-5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1219.09,67.4c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.22-33.19-45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1227.67,67.12c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.44-33.36-45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1228.68,66.94c-7.62.11-20.28-5.93-21.77-6.78-22.94-13.12-26.53-33.95-43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1219.68,50.71c-31.09-11.09-27-24.63-43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-efc86bee-faa7-4490-adca-c5b3a3e1bcab",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1632.34,53.53c2.68,2.1,7.06.94,8.82-1.98s1.05-6.91-1.17-9.49c-1.38-1.6-3.28-2.74-5.34-3.2-3.78-.85-7.76.6-10.93,2.83-3.17,2.22-5.74,5.18-8.56,7.85-15.9,15.08-35.77,18.75-58.07,18.97-7.32-.23-27.82,1.8-33.17-11.4-1-2.46-1.37-5.12-1.63-7.76-.51-5.22-.52-10.86,2.37-15.24,2.45-3.72,6.71-5.97,11.07-6.88,4.36-.91,8.88-.64,13.32-.25,6.22,1.01,8.42,7.07,8.5,9.32.21,5.99-.09,12.8-5.36,15.66-2.1,1.14-4.54,1.46-6.92,1.54-3.24.11-6.65-.25-9.34-2.07s-4.38-5.42-3.14-8.42c1.33-3.22,5.98-6.98,14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1627.4,26.25c2.26-.43,4.56-.71,6.86-.53,5.72.45,13.99,3.52,17.34,8.18,3.35,4.67,8.49,18.7-1.42,29.31-4.55,4.65-13.9,5.48-16.27,5.46-5.38-.04-10.13-1.84-13.04-6.37-1.82-2.82-3.16-7.99-2.33-11.25.82-3.26,2.31-6.35,5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1552.78,68.64c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.22-33.19,45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1544.2,68.36c7.62.11,18.04-.84,25.07-4.96,1.48-.87,2.94-1.77,4.42-2.62,22.94-13.12,28.44-33.36,45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1543.2,68.18c7.62.11,20.28-5.93,21.77-6.78,22.94-13.12,26.53-33.95,43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1552.2,51.95c31.09-11.09,27-24.63,43.9-26.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-1972c5da-ade9-4be3-a668-37434b19144d",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1409.53,52.82c-2.68,2.1-7.06.94-8.82-1.98s-1.05-6.91,1.17-9.49c1.38-1.6,3.28-2.74,5.34-3.2,3.78-.85,7.76.6,10.93,2.83s5.74,5.18,8.56,7.85c15.9,15.08,35.77,18.75,58.07,18.97,7.32-.23,27.82,1.8,33.17-11.4,1-2.46,1.37-5.12,1.63-7.76.51-5.22.52-10.86-2.37-15.24-2.45-3.72-6.71-5.97-11.07-6.88-4.36-.91-8.88-.64-13.32-.25-6.22,1.01-8.42,7.07-8.5,9.32-.21,5.99.09,12.8,5.36,15.66,2.1,1.14,4.54,1.46,6.92,1.54,3.24.11,6.65-.25,9.34-2.07s4.38-5.42,3.14-8.42c-1.33-3.22-5.98-6.98-14.22-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1414.47,25.55c-2.26-.43-4.56-.71-6.86-.53-5.72.45-13.99,3.52-17.34,8.18-3.35,4.67-8.49,18.7,1.42,29.31,4.55,4.65,13.9,5.48,16.27,5.46,5.38-.04,10.13-1.84,13.04-6.37,1.82-2.82,3.16-7.99,2.33-11.25s-2.31-6.35-5.19-9.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1489.09,67.93c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.22-33.19-45.12-34.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1497.67,67.65c-7.62.11-18.04-.84-25.07-4.96-1.48-.87-2.94-1.77-4.42-2.62-22.94-13.12-28.44-33.36-45.34-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1498.67,67.47c-7.62.11-20.28-5.93-21.77-6.78-22.94-13.12-26.53-33.95-43.44-35.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M1489.67,51.24c-31.09-11.09-27-24.63-43.9-26.25"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M26.51,12.24s1380.54,3.02,1632.95,3.27c10.15-.06,9.95,9.56,0,9.41-380.28-.97-1307.93-2.8-1632.95-3.27-6.9.24-7.57-9.11,0-9.41Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M27.88,74.97s1380.54,3.02,1632.95,3.27c10.15-.06,9.95,9.56,0,9.41-380.28-.97-1307.93-2.8-1632.95-3.27-6.9.24-7.57-9.11,0-9.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M27.18,218.96s1380.54,3.02,1632.95,3.27c10.15-.06,9.95,9.56,0,9.41-380.28-.97-1307.93-2.8-1632.95-3.27-6.9.24-7.57-9.11,0-9.41Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-c7b5ef8b-82bf-45e8-8352-adad9f653c32",
    "data-name": "_x32__lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 54.78,
    y1: 159.71,
    x2: 55.4,
    y2: 218.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 54,
    y1: 84.45,
    x2: 54.58,
    y2: 139.91
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 1633.42,
    y1: 162.74,
    x2: 1633.1,
    y2: 222.16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 1633.8,
    y1: 90.05,
    x2: 1633.52,
    y2: 142.94
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M27.65,140.28s1380.54,3.02,1632.95,3.27c10.15-.06,9.95,9.56,0,9.41-380.28-.97-1307.93-2.8-1632.95-3.27-6.9.24-7.57-9.11,0-9.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    d: "M54.47,159.51c-9.42-.01-18.45-.03-27.05-.04-6.9.24-7.57-9.11,0-9.41,0,0,1380.54,3.02,1632.95,3.27,10.15-.06,9.95,9.56,0,9.41-370.22-.94-1259.22-2.7-1605.9-3.23"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-99b9bd2e-49d7-4f89-8488-e24576b3d63d",
    "data-name": "_x32__lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 371.62,
    y1: 160.24,
    x2: 372.23,
    y2: 219.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 370.83,
    y1: 84.98,
    x2: 371.41,
    y2: 140.43
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-1e605f17-63be-42c8-bd42-5a341ba9d0fe",
    "data-name": "_x32__lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 691.42,
    y1: 161.29,
    x2: 692.04,
    y2: 220.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 690.64,
    y1: 86.03,
    x2: 691.22,
    y2: 141.48
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-b040a2f5-a2ff-4f90-be8d-27f3b55c62f3",
    "data-name": "_x32__lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 1009.13,
    y1: 161.99,
    x2: 1009.75,
    y2: 220.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 1008.35,
    y1: 86.72,
    x2: 1008.93,
    y2: 142.18
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-902bb3db-479a-410d-9821-af4456780e46",
    "data-name": "_x32__lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 1325.27,
    y1: 163.56,
    x2: 1325.88,
    y2: 222.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-c41cdd11-88e3-4635-b259-c9fbfb77f319",
    x1: 1324.48,
    y1: 88.3,
    x2: 1325.06,
    y2: 143.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPillar);
export default __webpack_public_path__ + "static/media/projectPillar.6dc19cec7e16bd5ae0e87a83d412dcd7.svg";
export { ForwardRef as ReactComponent };